(() => {
    function loadAddShoppers() {
      if (window.__addshoppers_loaded) return;
      window.__addshoppers_loaded = true;
  
      const t = document.createElement("script");
      t.type = "text/javascript";
      t.async = true;
      t.id = "AddShoppers";
      t.src = "https://shop.pe/widget/widget_async.js#5fac5a6273efc3570f688b42";
      document.head.appendChild(t);
    }
  
    function schedule() {
      if ("requestIdleCallback" in window) {
        requestIdleCallback(loadAddShoppers, { timeout: 2000 });
      } else {
        setTimeout(loadAddShoppers, 1500);
      }
    }
  
    window.addEventListener("load", schedule, { once: true });
  })();